import i18n from 'shared/lib/i18n';

export const getCallStatusOptions = () => [
  {
    value: 'busy',
    label: i18n.t('callStatuses.busy'),
  },
  {
    value: 'in-progress',
    label: i18n.t('callStatuses.inProgress'),
  },
  {
    value: 'no-answer',
    label: i18n.t('callStatuses.noAnswer'),
  },
  {
    value: 'completed',
    label: i18n.t('callStatuses.completed'),
  },
  {
    value: 'failed',
    label: i18n.t('callStatuses.failed'),
  },
  {
    value: 'canceled',
    label: i18n.t('callStatuses.canceled'),
  },
];

export const CALL_EVENTS_NAMES = {
  task_queue_entered: 'Call Started',
  reservation_created: 'Call Assigned to Agent',
  reservation_accepted: 'Call Answered',
  assignment_rejected: 'Call Assignment Timed Out',
  assignment_timed_out: 'Call Assignment Rejected',
  call_ended: 'Call Ended',
  forwarded_out: 'Call Forwarded to External Call Center',
  task_canceled: 'Flex Leg Disconnected',
};

export const CALL_CENTER_ACTION_OPTIONS = [
  'reservation_created',
  'assignment_timed_out',
  'assignment_rejected',
  'reservation_accepted',
  'forwarded_out',
  'status_changed',
  'dial_call_status_changed',
  'call_ended',
  'task_queue_entered',
  'task_canceled',
  'agent_status_changed',
];

export const TWILIO_CALLS_LOGS_URL =
  'https://www.twilio.com/console/voice/calls/logs/';
